var React = require('react');

function Accessibility (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.24,5.55a.66.66,0,0,0,0,.14V5.55Z","fill":"#000001","key":0}),React.createElement("path",{"d":"M17,13.73a2.32,2.32,0,1,1-3.32-2.09V5.69a1.74,1.74,0,0,0-3.48,0V12a.57.57,0,0,1,0,.13A3.73,3.73,0,0,1,2.76,12V6.05a2.32,2.32,0,1,1,2,0V12a1.74,1.74,0,1,0,3.47,0V5.69a.66.66,0,0,1,0-.14,3.74,3.74,0,0,1,7.47.14v6A2.32,2.32,0,0,1,17,13.73Z","fill":"#1e80eb","key":1})]);
}

Accessibility.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Accessibility;

Accessibility.default = Accessibility;
